import ConnectedAppAndUser from '../adapter/sfdc/tabs/ConnectedAppAndUser'
import InDbConfig from './testdata/indb/InDbConfig'
import InDbJob from './testdata/indb/InDbJob'
import InDbPolicy from './testdata/indb/InDbPolicy'
import SoapPolicies from "./testdata/soap/SoapPolicies"
import CsvFiles from './testdata/soap/webtokenizer/CsvWebTokenizer'
import CsvConfiguration from "./webdav/tabs/CsvConfiguration"
import CsvPolicies from "./webdav/tabs/CsvPolicies"
import RESTProtectionConfiguration from "./restencryption/tabs/RESTProtectionConfiguration";

const AppConfig: any = {
  'de.eperi.testdata.indb': [
    {
      eventKey: 'InDbConfig',
      title: 'Database Connection',
      Component: InDbConfig,
    },
    {
      eventKey: 'InDbPolicy',
      title: 'Policies',
      Component: InDbPolicy,
    },
    {
      eventKey: 'InDbJob',
      title: 'Jobs',
      Component: InDbJob,
    },
  ],
  'de.eperi.testdata.soap': [
    {
      eventKey: 'SoapPolicies',
      title: 'Policies',
      Component: SoapPolicies,
    },
    {
      eventKey: 'CsvFile',
      title: 'CSV Files',
      Component: CsvFiles,
    },
  ],
  'de.eperi.webdav' : [
    {
      eventKey: 'Configuration',
      title: 'Configuration',
      Component: CsvConfiguration,
    },
    {
      eventKey: 'Policies',
      title: 'Policies',
      Component: CsvPolicies
    },
  ],
  'de.eperi.ca.salesforce': [
    {
      eventKey: 'AppWithUser',
      title: 'Connected App & User',
      Component: ConnectedAppAndUser,
    },
  ],
  'de.eperi.restprotection' : [
    {
      eventKey: 'Configuration',
      title: 'Configuration',
      Component: RESTProtectionConfiguration,
    }
  ]
}

export default AppConfig
